export function createThreadAbortController(threadId) {
  const controller = new AbortController()
  controller.threadId = threadId
  return controller
}

export function abortRequestForDifferentThread(chatAbortRef, threadId) {
  const controller = chatAbortRef.current
  if (controller?.threadId === threadId) return
  controller?.abort()
}
